const ResponseKind = {
    PONG: "PONG",
    USER_DETAILS: "USER_DETAILS",
    PROGRESS: "PROGRESS",
    RESULTS: "RESULTS",
    DOMAINS: "DOMAINS",
    VOTE: "VOTE",
    ERRORS: "ERRORS",

    PRE_PURCHASE_INFO: "PRE_PURCHASE_INFO",
    PAYMENT_INTENT: "PAYMENT_INTENT",
    PREPARE_FOR_MONEY: "PREPARE_FOR_MONEY",
    TXN_STATUS: "TXN_STATUS",
};

export default Object.freeze(ResponseKind);